import { languageChoices } from '@hotjar/insights-common/constants/legacy';
import type { SurveySectionKey } from '../../common/Wizard/Wizard';

export const wizardSections: SurveySectionKey[] = [
  'name',
  'location',
  'questions',
  'appearance',
  'invitation',
  'targeting',
  'behavior',
  'forwarding',
];

export const getLanguageLabelByCode = (languageCode: string): string =>
  languageChoices.find(({ value }) => value === languageCode)?.label ?? languageCode;
